export default async function (redirect: string): Promise<void> {
  await navigateTo(redirect, { redirectCode: 301, replace: true })
}
